import Entity from "@/services/westore/entities/entity";

export class Tracking extends Entity {
  static uri = "/orders";
  static getTracking(id) {
    return super.get(`${Tracking.uri}/track?order_number=${id}`);
  }
}
